<script>
    import { expandAll } from "./Stores";

    function toggleExpandAll() {
        $expandAll = !$expandAll;
    }
</script>

<label class="relative inline-flex items-center cursor-pointer mt-3">
    <input
        type="checkbox"
        checked={$expandAll}
        class="sr-only peer"
        on:click={toggleExpandAll}
    />
    <div
        class="w-11 h-6 bg-gray-800 peer-focus:outline-none rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-cyan-700"
    />
    <span class="ml-3 md:text-base text-sm text-neutral-100">Expandir tudo</span
    >
</label>
